import { join } from 'juriquery'

import { Query } from '../types'

export const DOCUMENTS_ROOT_ROUTE = '/credentialing'
export const DOCUMENTS_UPLOAD_ROUTE = `upload`
export const DOCUMENTS_USERS_ROUTE = `users`
export const DOCUMENTS_USER_DOCS_ROUTE = `users/:userId/docs`
export const DOCUMENTS_USER_DOC_ROUTE = `users/:userId/docs/:docId`
export const DOCUMENTS_USER_DOC_SIGN_ROUTE = `/clinics/:clinicId/credentialing/users/:userId/docs/:documentId/sign/:signatureId`

export const getDocumentsRoute = () => DOCUMENTS_ROOT_ROUTE

export const getDocumentsUsersRoute = (query?: Query) =>
  join(`${getDocumentsRoute()}/users`, query)

const getRouteWithInjectedUserId = (route: string, userId: number) =>
  route.replace(':userId', `${userId}`)

export const getDocumentsUserDocsRoute = (userId: number, query?: Query) =>
  join(
    `${getDocumentsRoute()}/${getRouteWithInjectedUserId(
      DOCUMENTS_USER_DOCS_ROUTE,
      userId,
    )}`,
    query,
  )

const getRouteWithInjectedDocId = (
  route: string,
  userId: number,
  docId: number,
) => getRouteWithInjectedUserId(route, userId).replace(':docId', `${docId}`)

export const getDocumentsUserDocRoute = (
  userId: number,
  docId: number,
  query?: { page?: number; limit?: number } & Query,
) =>
  join(
    `${getDocumentsRoute()}/${getRouteWithInjectedDocId(
      DOCUMENTS_USER_DOC_ROUTE,
      userId,
      docId,
    )}`,
    query,
  )

export const getDocumentsUploadRoute = () =>
  `${getDocumentsRoute()}/${DOCUMENTS_UPLOAD_ROUTE}`
